import React, { useContext } from 'react'
import { UnitContext } from '../../App';
import CMLDetailsScreen from './CMLDetailsScreen';
import { Loading } from '@sede-enterprise/shell-ds-react-framework';
import useLogReport from '../../util/hooks/useLogReport';
import useFetchCMLDetails from './hooks/useFetchCMLDetails';

export const sensor_filter = `excludeFromUi=="false"`

const CMLDetailsContainer = (props) => {
    const unitContext = useContext(UnitContext);
    const { match } = props;

    // Log report for the page
    useLogReport('CML DETAIL');
    const { cmlCorrosionLoop, cmlSite, cmlData, cmlShortName } = useFetchCMLDetails(decodeURIComponent(match.params.id));

    if (!cmlCorrosionLoop || !cmlSite) return <div className="sensor-details-loading loading-container" role='status'>
        <Loading />
    </div>;

    return (
        <CMLDetailsScreen
            units={unitContext.units}
            cmlID={decodeURIComponent(match.params.id)}
            equipmentId={cmlData?.equipment}
            cmlShortName={cmlShortName}
            cmlCorrosionLoop={cmlCorrosionLoop}
            cmlSite={cmlSite}
            cmlData={cmlData}
            prodUnit={cmlData?.plant}

        />
    )
}

export default CMLDetailsContainer